<script>
  import AccordionGroup from "../Components/Accordion/AccordionGroup.svelte";
  import AccordionItem from "../Components/Accordion/AccordionItem.svelte";

  export let title, parentId;
</script>

<AccordionGroup {title} {parentId}>
  <AccordionItem>
    <div slot="header">
      When will I receive my registration renewal reminder email or text
      messages I have signed up for?
    </div>
    <div slot="content">
      You will receive a pre-renewal notice 90 days prior to the Renewal due
      date and a renewal notice 7 days later.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      If I sign up for email and text message Renewal Reminders will I still
      receive a Renewal notice via postage mail?
    </div>
    <div slot="content">
      <ol type="a">
        <li>
          Email: You will only receive a Renewal Reminder(s) via postage mail if
          our records indicate that the vehicle license plate will expire within
          seven (7) days.
        </li>
        <li>
          Text message: You will receive a Renewal Reminder(s) via postage mail.
        </li>
      </ol>
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      What if I no longer want to receive Renewal Reminder emails and text
      messages?
    </div>
    <div slot="content">
      You will need to login to the Renewal Reminder page and remove the email
      address(es) and phone number(s) that you would no longer like to use to
      receive the Renewal Reminder messages.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      Will I be charged to receive the Renewal Reminder via text on my cell
      phone?
    </div>
    <div slot="content">
      It depends on the phone rate plan you have whether your provider charges
      you for receiving the text message. You will need to check with your phone
      provider if you are not sure how your plan works for text messaging.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      Why do I need a Driver's License to register for renewal reminders?
    </div>
    <div slot="content">
      A drivers license and full name is required to verify the reminders
      associated to your account.
    </div>
  </AccordionItem>
  <AccordionItem>
    <div slot="header">
      Will I receive an email or text message renewal reminder for my driver’s
      license?
    </div>
    <div slot="content">
      No, Online Renewal Reminder notifications are only available for your
      Renewal Registration and not for your driver’s license renewals.
    </div>
  </AccordionItem>
</AccordionGroup>
